/**
 * Coerce any error-message shape into a readable string so UI surfaces (alerts,
 * inline error text) never render "[object Object]". Backends/providers
 * sometimes return `message` as an object or an array (class-validator); this
 * flattens those to a string.
 *
 * Dependency-free on purpose so it can be imported by any service without
 * risking an import cycle.
 *
 * @param {*} value - raw message (string | array | object | null)
 * @returns {string} readable message ('' for null/undefined)
 */
export const formatErrorMessage = (value) => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.filter(Boolean).map(String).join('; ');
  if (typeof value === 'object') {
    if (typeof value.message === 'string') return value.message;
    try {
      return JSON.stringify(value);
    } catch {
      return '';
    }
  }
  return String(value);
};
